import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { OfflineTutorialsPage } from './offline-tutorials.page';
import { BotModule } from '@app/bot/bot.module';
import { SharedModule } from '@app/shared/shared.module';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    BotModule,
    SharedModule
  ],
  declarations: [OfflineTutorialsPage]
})
export class OfflineTutorialsPageModule {}
